import Enterprise24 from '@carbon/icons-react/es/enterprise/24';
import Enterprise32 from '@carbon/icons-react/es/enterprise/32';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';
import styled, { css } from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { SingleLineOption } from 'components/atoms/select/custom-components';
import {
  Option,
  SingleValue,
  OptionProps,
} from 'components/atoms/select/types';
import { TitleSelect } from './title-select';
import { TitleSelectTrigger } from './title-select-trigger';

const Trigger = ({ value: option }): JSX.Element => {
  if (option.value === 0) {
    return <TitleSelectTrigger icon={<Enterprise32 />} label={option.label} />;
  }

  return (
    <TitleSelectTrigger
      icon={<Avatar name={option.label} src={option.imageUrl} size={32} />}
      label={option.label}
      description={option.description}
    />
  );
};

const NonProjectItem = styled.div<{ isSelected }>`
  display: flex;
  align-items: center;
  svg {
    margin-right: 1rem;
  }
  ${({ isSelected }) =>
    isSelected
      ? css`
          color: var(--white-100);
        `
      : css`
          color: var(--gray-80);
        `};
`;

const ProjectOption = (props: OptionProps): JSX.Element => {
  const { data, isSelected, ...restProps } = props;

  if (data.value === 0) {
    return (
      <>
        <components.Option data={data} isSelected={isSelected} {...restProps}>
          <NonProjectItem isSelected={isSelected}>
            <Enterprise24 />
            <span>{data.label}</span>
          </NonProjectItem>
        </components.Option>
      </>
    );
  }

  return <SingleLineOption {...props} />;
};

interface Props {
  options: Option[];
  onChange: (value: SingleValue<number>) => void;
  selected?: Option;
}
export const ProjectSelect: FC<Props> = ({ options, onChange, selected }) => {
  return (
    <TitleSelect
      options={options}
      onChange={onChange}
      selected={selected}
      triggerComponent={Trigger}
      components={{ Option: ProjectOption }}
      noOptionsMessage={() => (
        <FormattedMessage id="projects.no_results.empty.title" />
      )}
    />
  );
};
